import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import { painPoints, planningQuestions, scratchHabits } from '../data/painPoints';
const reveal = {
  initial: {
    opacity: 0,
    y: 16
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true
  },
  transition: {
    duration: 0.3,
    ease: [0.23, 1, 0.32, 1]
  }
} as const;
export function PainPoints() {
  return <section className="py-24 px-4 bg-white" data-id="element-150" data-mp="1xwoke8yiwwqo">
      <div className="max-w-4xl mx-auto" data-id="element-151" data-mp="1y042lknhulwb">
        <motion.div {...reveal} className="text-center mb-12" data-id="element-152" data-mp="21zl7ocz0dh0y">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-blue-950" data-id="element-153" data-mp="1nzjz0bci55ax">
            Still Spending Hours Planning Every Driving Lesson?
          </h2>
          <div className="text-lg text-slate-800 leading-relaxed bg-stone-50 p-6 md:p-8 rounded-2xl border border-stone-200 text-left space-y-4" data-id="element-154" data-mp="1sywwdq101urr">
            <p data-id="element-155" data-mp="3ncfryubgz3af">
              Another student.
              <br data-id="element-156" data-mp="3nc60116v6m23" />
              Another lesson.
              <br data-id="element-157" data-mp="1z0exyqe3uy49" />
              Another evening deciding:
            </p>
            <ul className="space-y-2 pl-1" data-id="element-158" data-mp="1yyc2hqu6ocs5">
              {planningQuestions.map(question => <li key={question} className="flex items-start gap-3 text-blue-950 font-semibold" data-id="element-159" data-mp="1u1bwffxc3a11">
                  <div size={20} className="text-orange-600 shrink-0 mt-1" aria-hidden="true" data-id="element-160" data-mp="27s74wr3x7p43" />
                  <span data-id="element-161" data-mp="23s6s1awgzlz5">{question}</span>
                </li>)}
            </ul>
            <p data-id="element-162" data-mp="1g2lw7rf7wu8g">
              <span className="text-blue-950 font-semibold" data-id="element-163" data-mp="1g22qd92udwas">
                Not because you don&apos;t know how to teach driving.
              </span>{' '}
              Because knowing how to drive and having a complete teaching system are two very
              different things.
            </p>
            <p className="text-blue-950 font-semibold" data-id="element-164" data-mp="1k1uth69gva8r">
              Without a system, every student can feel like another lesson you need to build from
              scratch.
            </p>
            <p data-id="element-165" data-mp="2vi1i59s5jfov">{scratchHabits.join(' ')}</p>
            <p data-id="element-166" data-mp="1t55800xgijss">And the time you should spend teaching becomes planning time.</p>
          </div>
        </motion.div>

        <motion.div {...reveal} data-id="element-167" data-mp="1y3qak706lfke">
          <h3 className="text-xl font-bold text-blue-950 mb-8 text-center uppercase tracking-wide" data-id="element-168" data-mp="1y2oo76dpt6nd">
            The Real Cost of Planning Everything From Scratch
          </h3>
          <div className="overflow-hidden rounded-xl border border-stone-200 bg-white shadow-sm shadow-blue-950/5" data-id="element-169" data-mp="27568hf9t7p7q">
            {painPoints.map((point, index) => <motion.p key={point} initial={{
            opacity: 0,
            x: -12
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.25,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex items-start gap-3 px-5 py-4 text-slate-800 text-sm leading-relaxed border-t first:border-t-0 border-stone-200" data-id="element-170" data-mp="1acucis54to4p" data-mpi={index}>
                <X size={16} className="text-red-600 shrink-0 mt-0.5" aria-hidden="true" data-id="element-171" data-mp="vo6m10a584lm" />
                {point}
              </motion.p>)}
          </div>

          <div className="text-center mt-12 pt-8 border-t border-stone-200" data-id="element-172" data-mp="j6nfiqwcqv8b">
            <p className="text-2xl font-serif font-bold text-blue-950" data-id="element-173" data-mp="e82dqn1gc3hr">
              Your driving knowledge is already there.
            </p>
            <p className="text-xl mt-4 text-slate-800" data-id="element-174" data-mp="a5fisd9hi2gc">
              What you need is a <span className="text-orange-600 font-semibold" data-id="element-175" data-mp="57w3rb4yplnc">system</span> that
              helps you use it faster, more visually and more professionally.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}